import { EmptystateUsedByColored } from "components/icons/generated";
import EmptyState from "ds/components/EmptyState";

const SpaceliftVcsRepoUsedByEmpty = () => {
  return (
    <EmptyState
      title="No stacks are using this repository yet"
      icon={EmptystateUsedByColored}
      caption="Create a stack that references this repository to see it here."
    />
  );
};

export default SpaceliftVcsRepoUsedByEmpty;
